import { useActiveOrganizationAssignment } from "./useActiveOrganizationAssignment";

export function useActiveOrganizationRole() {
    const activeOrganizationAssignment = useActiveOrganizationAssignment();

    return activeOrganizationAssignment?.role ?? null;
}
